import { AppointmentSmartSuggestModel } from "./appointment-smartsuggest.model";

export class AppointmentSmartSuggestionModel {
    Input: string;
    SelectedInputEntries: AppointmentSmartSuggestModel[];
    SelectedRegionEntries: any;
    /**
     *
     */
    constructor(destination?: AppointmentSmartSuggestModel[], regionDestination?: any) {
        this.SelectedInputEntries = destination || [];
        this.SelectedInputEntries = regionDestination || [];
        this.Input = '';
    }
}